export const DASHBOARD_SOURCES: Readonly<Record<string, string>> = {
  organizations: 'GET /backoffice/organizations',
  organizationsByStatus: 'GET /backoffice/organizations?status=',
  users: 'GET /backoffice/users',
  systemUsers: 'GET /backoffice/system-users',
  plans: 'GET /backoffice/plans',
  planSubscribers: 'GET /backoffice/plans/{plan}/subscribers',
  markets: 'GET /backoffice/markets',
};
